<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <div class="flex flex-row">
          <h3 class="mr-4">{{ title }}</h3>
          <div v-if="!isLoading">
            <vs-chip color="primary">{{
              numVenueCampaignsForApproval
            }}</vs-chip>
          </div>
        </div>
        <p class="mt-2">{{ description }}</p>
      </vs-col>
    </vs-row>

    <div
      v-if="isLoading"
      class="flex flex-col justify-center items-center mt-12 pt-12"
    >
      <span class="flex h-6 w-6 mb-5">
        <span
          class="animate-ping absolute inline-flex h-6 w-6 rounded-full bg-primary opacity-75"
        ></span>
        <span
          class="relative inline-flex rounded-full h-6 w-6 bg-primary"
        ></span>
      </span>
      <span> Loading</span>
    </div>

    <div v-if="!isLoading">
      <h5 class="mt-6">Filter by country</h5>

      <vs-row vs-justify="flex-start" class="mt-4">
        <vs-button
          class="rounded-none rounded-l-lg w-48"
          :color="showDenmark ? 'primary' : 'grey'"
          @click="showDenmark = !showDenmark"
          :icon="showDenmark ? 'check' : ''"
        >
          Denmark
        </vs-button>
        <vs-button
          class="rounded-none w-48"
          :color="showNorway ? 'primary' : 'grey'"
          @click="showNorway = !showNorway"
          :icon="showNorway ? 'check' : ''"
        >
          Norway
        </vs-button>
        <vs-button
          class="rounded-none w-48 rounded-r-lg"
          :color="showFinland ? 'primary' : 'grey'"
          @click="showFinland = !showFinland"
          :icon="showFinland ? 'check' : ''"
        >
          Finland
        </vs-button>
        <!-- <vs-button
          class="rounded-none w-48 rounded-r-lg"
          :color="showUK ? 'primary' : 'grey'"
          @click="showUK = !showUK"
          :icon="showUK ? 'check' : ''"
        >
          United Kingdom
        </vs-button> -->
      </vs-row>

      <div class="mt-4">
        <span class="text-grey font-bold"
          >Number of campaigns matched by filter:
          {{ filteredVenueCampaingsForApproval.length }}</span
        >
      </div>
    </div>

    <!-- table -->
    <div v-if="!isLoading" id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="25"
        search
        :data="filteredVenueCampaingsForApproval"
        @selected="onClicked(selected)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="venueName">Venue</vs-th>
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="sendEmailDate">Email send date</vs-th>
          <vs-th sort-key="sendSmsDate">Sms send date</vs-th>
          <vs-th sort-key="sendNpPushDate">Notification send date</vs-th>
          <vs-th>Who submitted</vs-th>
          <vs-th>Action</vs-th>
          <!-- <vs-th sort-key="isBasedOnMasterCampaign">Type</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                {{ tr.venueName }}
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.title }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="statusObject(tr.status).color"
                  class="product-order-status"
                >
                  {{ statusObject(tr.status).text }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <span v-if="tr.hasEmail">
                  <vs-chip
                    v-if="isDateLateForStatus(tr.sendEmailDate, tr.status)"
                    color="danger"
                  >
                    {{ tr.sendEmailDate | formatDate }}
                  </vs-chip>
                  <span v-else>
                    {{ tr.sendEmailDate | formatDate }}
                  </span>
                </span>
                <span v-else>-</span>
              </vs-td>
              <vs-td>
                <span v-if="tr.hasSms">
                  <vs-chip
                    v-if="isDateLateForStatus(tr.sendSmsDate, tr.status)"
                    color="danger"
                  >
                    {{ tr.sendSmsDate | formatDate }}
                  </vs-chip>
                  <span v-else>
                    {{ tr.sendSmsDate | formatDate }}
                  </span>
                </span>
                <span v-else>-</span>
              </vs-td>
              <vs-td>
                <span v-if="tr.hasNpPush">
                  <vs-chip
                    v-if="isDateLateForStatus(tr.sendNpPushDate, tr.status)"
                    color="danger"
                  >
                    {{ tr.sendNpPushDate | formatDate }}
                  </vs-chip>
                  <span v-else>
                    {{ tr.sendNpPushDate | formatDate }}
                  </span>
                </span>
                <span v-else>-</span>
              </vs-td>
              <vs-td>
                {{
                  tr.submittedAction ? tr.submittedAction.userDisplayName : "-"
                }}
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  v-if="hasPermission('vp.crm.campaigns.edit')"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <preview-popup ref="previewPopup" v-on:onSubmit="refreshCampaigns" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import campaignMixin from "@/views/mixins/campaignMixin";
import PreviewPopup from "./Components/MasterCampaign/PreviewCampaignPopup.vue";
import moment from "moment";

export default {
  components: {
    PreviewPopup,
  },
  mixins: [campaignMixin],
  props: ["title", "description"],
  data() {
    return {
      newMessageTitle: "",
      selected: [],
      isLoading: true,

      showSubmitted: true,
      showApproved: false,
      showRejected: false,
      showSent: false,
      showArchived: false,
      showCancelled: false,
      showDenmark: true,
      showNorway: true,
      showFinland: true,
      showUK: true,
    };
  },
  methods: {
    venueCountryByVenueId(id) {
      return this.globalVenues.find((venue) => venue.venueId === id).country;
    },
    onClicked(venueCampaign) {
      this.$refs.previewPopup.show(venueCampaign, null, true);
    },
    async refreshCampaigns() {
      this.isLoading = true;
      await this.$store.dispatch("venueCampaigns/getForApproval");
      this.isLoading = false;
    },
    isDateLateForStatus(date, status) {
      return (
        (status == "SubmittedForApproval" || status == "Rejected") &&
        moment(date).isBefore(moment())
      );
    },

    confirmDelete(campaign) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to Cancel the campaign '${campaign.title}'?`,
        accept: async () => {
          try {
            await this.$store.dispatch("venueCampaigns/delete", {
              venueCampaignId: campaign.id,
              byHQ: true,
            });
            this.$vs.notify({
              color: "green",
              title: "Success",
              text: `Cancel campaign was successful`,
            });

            await this.refreshCampaigns();
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign not cancelled",
              text: err,
              time: 4000,
            });
          }
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      globalVenues: "venues/globalVenues",
      activeVenue: "venues/activeVenue",
    }),
    venueCampaignsForApproval() {
      return this.$store.getters[`venueCampaigns/venueCampaignsForApproval`];
    },
    numVenueCampaignsForApproval() {
      return this.venueCampaignsForApproval.filter(
        (campaign) => campaign.status === "SubmittedForApproval"
      ).length;
    },
    filteredVenueCampaingsForApproval() {
      let campaigns = this.venueCampaignsForApproval;

      if (!this.showDenmark) {
        campaigns = campaigns.filter(
          (campaign) =>
            this.venueCountryByVenueId(campaign.venueId) !== "Denmark"
        );
      }

      if (!this.showNorway) {
        campaigns = campaigns.filter(
          (campaign) =>
            this.venueCountryByVenueId(campaign.venueId) !== "Norway"
        );
      }

      if (!this.showFinland) {
        campaigns = campaigns.filter(
          (campaign) =>
            this.venueCountryByVenueId(campaign.venueId) !== "Finland"
        );
      }

      // if (!this.showUK) {
      //   campaigns = campaigns.filter(
      //     (campaign) =>
      //       this.venueCountryByVenueId(campaign.venueId) !== "United Kingdom"
      //   );
      // }

      if (!this.showArchived) {
        campaigns = campaigns.filter(
          (campaign) => campaign.status !== "Archived"
        );
      }
      if (!this.showSubmitted) {
        campaigns = campaigns.filter(
          (campaign) => campaign.status !== "SubmittedForApproval"
        );
      }
      if (!this.showApproved) {
        campaigns = campaigns.filter(
          (campaign) => campaign.status !== "Approved"
        );
      }
      if (!this.showRejected) {
        campaigns = campaigns.filter(
          (campaign) => campaign.status !== "Rejected"
        );
      }
      if (!this.showSent) {
        campaigns = campaigns.filter(
          (campaign) =>
            campaign.status !== "Sent" &&
            campaign.status !== "PartiallySent" &&
            campaign.status !== "ErrorSending"
        );
      }
      if (!this.showCancelled) {
        campaigns = campaigns.filter(
          (campaign) => campaign.status !== "Cancelled"
        );
      }

      // Sort by status. SubmittedForApproval first, then the rest last
      campaigns.sort((a, b) => {
        if (
          a.status === "SubmittedForApproval" &&
          b.status !== "SubmittedForApproval"
        ) {
          return -1;
        }
        if (
          a.status !== "SubmittedForApproval" &&
          b.status === "SubmittedForApproval"
        ) {
          return 1;
        }
        if (a.status === "Rejected" && b.status !== "Rejected") {
          return -1;
        }
        if (a.status !== "Rejected" && b.status === "Rejected") {
          return 1;
        }
        if (a.status === "Approved" && b.status !== "Approved") {
          return -1;
        }
        if (a.status !== "Approved" && b.status === "Approved") {
          return 1;
        }
        if (a.status === "PartiallySent" && b.status !== "PartiallySent") {
          return -1;
        }
        if (a.status !== "PartiallySent" && b.status === "PartiallySent") {
          return 1;
        }
        if (a.status === "Sent" && b.status !== "Sent") {
          return -1;
        }
        if (a.status !== "Sent" && b.status === "Sent") {
          return 1;
        }
        if (a.status === "Cancelled" && b.status !== "Cancelled") {
          return -1;
        }
        if (a.status !== "Cancelled" && b.status === "Cancelled") {
          return 1;
        }
        return 0;
      });

      return campaigns;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  async created() {
    this.refreshCampaigns();
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
